module.exports = __webpack_public_path__ + "img/about.b2103b91.webp";